import { ReactNode } from 'react';
import styled from 'styled-components';

const FancyMarkDownTable = ({ children }: { children: ReactNode }) => {
  return <Table>{children}</Table>;
};

const Table = styled.table`
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: left;
`;

export default FancyMarkDownTable;
